import React from 'react';
import PropTypes from 'prop-types';

const Spinner = (props) => {

    const spinnerClass = props.size == 'small' ? '_kanis_spinner_small' : '_kanis_spinner_large';

    return (
        <div className='_kanis_overlay'>
            <div className={spinnerClass}></div>
        </div>
    );
}

Spinner.propTypes = {
    size: PropTypes.oneOf(['small', 'large']).isRequired
};

export default Spinner;